const font = {
  primary: '"Futura-PT","Roboto", "Helvetica", "Arial", sans-serif',
  secondary: '"Lato","Roboto", "Helvetica", "Arial", sans-serif',
};

export { font };
